import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Installation`}</h1>
    <h2>{`npm`}</h2>
    <p>{`Tesfy could be installed via `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`npm`}</a>{` or `}<a parentName="p" {...{
        "href": "https://yarnpkg.com/"
      }}>{`yarn`}</a>{`. This is the recommended way to get the library.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install tesfy --save
# or
yarn add tesfy
`}</code></pre>
    <h2>{`CDN`}</h2>
    <p>{`Tesfy dist files are all avaliables from `}<a parentName="p" {...{
        "href": "https://www.jsdelivr.com/package/npm/tesfy"
      }}>{`jsDelivr`}</a>{` or `}<a parentName="p" {...{
        "href": "https://unpkg.com/"
      }}>{`unpkg`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script src="https://cdn.jsdelivr.net/npm/tesfy@1.0.0/dist/tesfy.umd.production.min.js"></script>
<!-- or -->
<script src="https://unpkg.com/tesfy@1.0.0/dist/tesfy.umd.production.min.js"></script>
`}</code></pre>
    <h2>{`Initialization`}</h2>
    <p>{`Once imported, instantiate the engine with a `}<inlineCode parentName="p">{`datafile`}</inlineCode>{` and optionally a `}<inlineCode parentName="p">{`storage`}</inlineCode>{` layer to enable sticky bucketing, a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and a set of `}<inlineCode parentName="p">{`attributes`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import * as Tesfy from 'tesfy';

const tesfy = new Tesfy.Engine({ datafile, storage, userId, attributes });
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      